import { FC } from "react";
import "./InfoBanner.scss";

export interface ILabelValue {
  label: string;
  value: string;
}

const InfoBanner: FC<{ labelValue: ILabelValue[] }> = ({ labelValue }) => {
  return (
    <div className="info-banner">
      <div className="info-banner__wrapper">
        {labelValue.map((lv) => (
          <div className="info-banner__wrapper-content">
            <p>{lv.label}</p>
            <p>{lv.value}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default InfoBanner;
